import React, {FunctionComponent, useEffect, useRef, useState} from "react";
import styles from "./Hero.module.scss";
import content from './content';
import classNames from "classnames";
import {scrollTo} from "../../libs/scroll";
import {fireSupGA} from "../../hooks/tagging";

const Hero: FunctionComponent<{ isStartSmart: boolean }> = ({isStartSmart}) => {
    const thisRef = useRef<HTMLParagraphElement>(null)
    const initialized = useRef(false)
    const getOffset = (target: any) => {
        return target!.getBoundingClientRect().top + (window.innerHeight / 2)
    }


    useEffect(() => {
        if (!initialized.current) {
            if (thisRef.current) {
                initialized.current = true;
                const sups = thisRef.current.querySelectorAll('A')
                sups.forEach((sup: any) => {
                    const keyUpHandler = (event: any) => {
                        if (event.which === 13) {
                            event.preventDefault();
                            event.stopPropagation();
                            fireSupGA({clickText: sup.innerText});
                            const target = document.getElementById(`fn-${sup.innerText}`)
                            const offset: number = getOffset(target);
                            scrollTo(offset, () => setTimeout(() => {
                                target?.focus()
                            }, 500), true);
                        }
                    }

                    sup.addEventListener('keydown', (e: any) => keyUpHandler(e));

                    const clickHandler = (event: any) => {
                        event.preventDefault();
                        event.stopPropagation();
                        fireSupGA({clickText: sup.innerText});
                        const target = document.getElementById(`fn-${sup.innerText}`)
                        const offset: number = getOffset(target);

                        scrollTo(offset, () => setTimeout(() => {
                            target?.focus()
                        }, 500), true);
                    }

                    sup.addEventListener('click', (e: any) => clickHandler(e));

                    return () => {
                        document.removeEventListener('keydown', keyUpHandler);
                        document.removeEventListener('click', clickHandler);
                    };
                })
            }

        }
    })
    useEffect(() => {
        if (thisRef.current) {


        }
    })

    return (<section id="hero" className={classNames([styles.hero, 'fullscreen'])} data-tracking="section-masthead" lang={process.env.REACT_APP_LANG === 'spanish' ? 'es' : 'en'}>

        <div lang={process.env.REACT_APP_LANG === 'spanish' ? 'es' : 'en'} className={styles.content}>
            <div lang={process.env.REACT_APP_LANG === 'spanish' ? 'es' : 'en'} className={styles.copy}>
                <p lang={process.env.REACT_APP_LANG === 'spanish' ? 'es' : 'en'} tabIndex={-1} id="main-content" ref={thisRef}>
                    {process.env.REACT_APP_LANG === 'spanish' ? content.spanish.default.headline : content.english[isStartSmart ? 'startsmart' : 'default'].headline}
                </p>
            </div>
        </div>
    </section>);
};

export default Hero;
